// extracted by mini-css-extract-plugin
module.exports = {"widget":"Calendar_widget__33dS0"};